var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3918 7.54565C45.3918 6.55481 44.589 5.75195 43.5982 5.75195H24.5963C23.6054 5.75195 22.8026 6.55481 22.8026 7.54565V18.9504C22.8026 19.9413 23.6054 20.7441 24.5963 20.7441H41.8045V25.8109L24.5963 43.0246L20.1642 38.5906C19.7884 38.2149 19.2628 38.0257 18.7364 38.0721C18.2071 38.1192 17.7259 38.3986 17.4227 38.8348L0.320908 63.4299C-0.0603113 63.9781 -0.105273 64.6927 0.204198 65.2846C0.513431 65.8768 1.12616 66.2475 1.79389 66.2475H70.2017C70.2036 66.2477 70.2055 66.2477 70.2065 66.2475C71.1973 66.2475 72.0002 65.4446 72.0002 64.4538C72.0002 64.0273 71.8514 63.6356 71.6029 63.3278L45.3918 25.987V7.54565ZM26.3899 17.1567V9.33934H41.8045V17.1567H26.3899ZM5.22558 62.6603L19.1434 42.6441L23.3275 46.8301C23.664 47.1664 24.1203 47.3556 24.5963 47.3556C25.0719 47.3556 25.5283 47.1664 25.8648 46.8301L43.3571 29.3321L66.7511 62.6605H5.22558V62.6603Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionSvg);
export default __webpack_public_path__ + "static/media/mission-svg.4ed2143b1f5c7efec6c919c32a89c452.svg";
export { ForwardRef as ReactComponent };